module.exports = __webpack_public_path__ + "6ad396399f4022ccd1616cf11d0985be.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-ExtraBold-webfont.woff
// module id = 1081
// module chunks = 0